<template>
  <div class="sidebar-wrapper">
    <div class="sidebar-content">
      <!-- Dashboard Item -->
      <ul class="sidebar-menu">
        <li class="sidebar-item dashboard-item" @click="navigateTo('dashboard')" :class="{ active: isDashboardActive }">
          <i class="sidebar-icon fas fa-home"></i>
          <span class="menu-name">Dashboard</span>
        </li>

        <!-- Dynamic Menu Items with Recursion -->
        <SidebarMenuItem
          v-for="item in rootMenuItems"
          :key="item.auto_id"
          :item="item"
          :allMenuData="menuData"
          @navigate="handleNavigation"
          @item-expanded="handleItemExpanded"
          :ref="`menuItem-${item.auto_id}`"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import SidebarMenuItem from './SidebarMenuItem.vue';

export default {
  name: 'DynamicSidebar',
  components: {
    SidebarMenuItem,
  },
  props: {
    menuData: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    rootMenuItems() {
      // Return items with parent_id === 0, sorted by order_id
      if (!this.menuData || this.menuData.length === 0) return [];
      
      return this.menuData
        .filter(item => item.parent_id === 0)
        .sort((a, b) => a.order_id - b.order_id);
    },
    isDashboardActive() {
      return this.$route.name === 'dashboard';
    },
  },
  methods: {
    navigateTo(route) {
      this.$router.push({ name: route }).catch(err => {
        console.warn(`Navigation to ${route} failed:`, err);
      });
    },
    handleNavigation(menuItem) {
      // Navigate to the route based on menu_action
      const routeName = menuItem.menu_action
        .toLowerCase()
        .replace(/\s+/g, '')
        .replace(/[^\w]+/g, '');
      
      // Check if route exists
      const routeExists = this.$router.getRoutes().some(route => route.name === routeName);
      
      if (routeExists) {
        this.$router.push({ name: routeName }).catch(err => {
          console.warn(`Navigation to ${routeName} failed:`, err);
        });
      } else {
        console.warn(`Route "${routeName}" not found`);
      }

      // Store permissions in localStorage
      localStorage.setItem('permissions', JSON.stringify(menuItem));

      // Emit event for parent component
      this.$emit('menuItemSelected', menuItem);
    },
    handleItemExpanded(expandedItem) {
      // Collapse all other root menu items (accordion behavior)
      this.rootMenuItems.forEach(item => {
        if (item.auto_id !== expandedItem.auto_id) {
          const menuItemRef = this.$refs[`menuItem-${item.auto_id}`];
          if (menuItemRef && menuItemRef[0]) {
            menuItemRef[0].collapseMenu();
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.sidebar-wrapper {
  width: 235px;
  background-color: #1a1d23;
  color: #ffffff;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.sidebar-content {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.sidebar-menu {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

.sidebar-item {
  display: flex;
  align-items: center;
  padding: 10px 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-left: 3px solid transparent;
  border-radius: 6px;
  margin: 4px 0;
  user-select: none;
}

.sidebar-item:hover {
  background-color: rgba(97, 218, 251, 0.1);
  border-left-color: #61dafb;
}

.sidebar-item.active {
  background-color: rgba(97, 218, 251, 0.2);
  border-left-color: #61dafb;
  font-weight: 600;
}

.sidebar-item.dashboard-item {
  margin-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 12px;
}

.sidebar-icon {
  min-width: 20px;
  margin-right: 12px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-name {
  font-size: 14px;
  font-weight: 500;
  white-space: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

/* Scrollbar styling */
.sidebar-wrapper::-webkit-scrollbar {
  width: 6px;
}

.sidebar-wrapper::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}

.sidebar-wrapper::-webkit-scrollbar-thumb {
  background: rgba(97, 218, 251, 0.4);
  border-radius: 3px;
}

.sidebar-wrapper::-webkit-scrollbar-thumb:hover {
  background: rgba(97, 218, 251, 0.6);
}
</style>
